import React from 'react';
import { FaSearch, FaTimes } from 'react-icons/fa';

function SearchFilter({ searchTerm, onSearchChange, selectedArchitecture, onArchitectureChange }) {
  const architectures = ['All', 'x86_64', 'arm64'];

  return (
      <div className="search-container">
        <label className="control-label">Search Layers</label>
        <div className="input-wrapper">
          <FaSearch className="search-icon" />
          <input 
            type="text"
            className="search-input"
            placeholder="Search by runtime, version, architecture, ARN..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          {searchTerm && (
            <button 
              className="clear-search-btn"
              onClick={() => onSearchChange('')}
              title="Clear search"
            >
              <FaTimes />
            </button>
          )}
        </div>
        
        <div className="architecture-filter">
          <label className="control-label">Architecture</label>
          <div className="architecture-chips">
            {architectures.map((arch) => (
              <button
                key={arch}
                className={`architecture-chip ${selectedArchitecture === arch ? 'active' : ''}`}
                onClick={() => onArchitectureChange(arch)}
              >
                {arch}
              </button>
            ))}
          </div>
        </div>
      </div>
  );
}

export default SearchFilter;
